<ng-select (change)="onChange($event)"
           [(ngModel)]="schoolActivityValue"
           [disabled]="isDisabled"
           [items]="schoolActivityData"
           [loading]="loading"
           bindLabel="activity_name"
           [placeholder]= "schoolActivityValue ? '' : ('SELECT' | translate) + ' ' + ('SCHOOL_ACTIVITY' | translate)"
           class="selector-style">
  <ng-template ng-option-tmp let-item="item">
    <div class="custom-option-style"  title="{{item.activity_name}} - {{item.activity_description}}">{{item.activity_name}}</div>
  </ng-template>
</ng-select>
